import React from "react";
import {
  Card,
  CardActionArea,
  CardActions,
  CardMedia,
  Typography,
  Box,
} from "@material-ui/core";
import { useStyles, ProjectCardLogic, PropTypes } from "./projectCard.module";
import ButtonDefault from "../button/button";

const ProjectCard = (props) => {
  const classes = useStyles();
  const { values, goToProject, language } = ProjectCardLogic(props);

  const buttonDisabled =
    values.project.only_showing && !values.project.show_without_purchase;

  return (
    <Card className={classes.cardRoot}>
      <CardActionArea
        classes={{ focusHighlight: classes.focus }}
        TouchRippleProps={{ className: classes.ripple }}
        className={classes.cardActionArea}
      >
        <Box className={classes.mediaContainer}>
          <CardMedia
            className={classes.cardMedia}
            image={values.project.image}
            title="Project Main Image"
          />
          <div className={classes.countryBadge}>
            {values.project.info[language]?.country?.toUpperCase()}
          </div>
        </Box>

        <Box className={classes.cardContent}>
          <div className={classes.categoryRow}>
            <Typography className={classes.categoryText}>
              {values.project.info[language]?.project_type ||
                values.project.info["en"]?.project_type ||
                "BIODIVERSITY CORRIDOR"}
            </Typography>
          </div>

          <Typography className={classes.projectTitle} variant="h2">
            {values.project.info[language]?.name?.toUpperCase()}
          </Typography>

          <Typography className={classes.projectDescription}>
            {values.project.description}
          </Typography>
        </Box>
      </CardActionArea>

      <CardActions className={classes.cardFooter}>
        <Box className={classes.statBox}>
          <Typography className={classes.statLabel}>OFFSET CAPACITY</Typography>
          <Typography className={classes.statValue}>
            {values.project.offset_capacity || "4.8M tCO2e"}
          </Typography>
        </Box>

        <ButtonDefault
          id={values.project.id}
          type="greenProjects"
          text={props.text}
          changeView={goToProject}
          disabled={buttonDisabled}
        ></ButtonDefault>
      </CardActions>
    </Card>
  );
};

ProjectCard.propTypes = {
  image: PropTypes.string,
  title_project: PropTypes.string,
  description: PropTypes.string,
};

export default ProjectCard;
